import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=22d28a33&scoped=true&"
import script from "./Image.vue?vue&type=script&lang=ts&"
export * from "./Image.vue?vue&type=script&lang=ts&"
import style0 from "./Image.vue?vue&type=style&index=0&id=22d28a33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d28a33",
  null
  
)

export default component.exports